import { Box, Stack } from '@mui/material'
import type { TPublisherLyricsApprovalDraftReviewSong } from '@modules/types'
import { SongsListFooter } from '../SongsListFooter'
import { SONGS_LIST_STRINGS } from '../strings'
import { SongItemApprovalLyrics } from './SongItemApprovalLyrics'
import { usePublisherApprovalLyrics } from './usePublisherApprovalLyrics'
import type { TPublisherApprovalRequestShowProps } from '../types'

export const PublisherApprovalLyricsRequest = ({
  requestId,
  selectedRequest,
  initialLoading,
  enums,
  apiUrl,
  onDrawerClose,
  onReviewSuccess,
  isRequestSubmitted,
}: TPublisherApprovalRequestShowProps) => {
  const songs = selectedRequest.songs || []
  const draftReviewSongs =
    (selectedRequest.draftReview?.songs as TPublisherLyricsApprovalDraftReviewSong[] | undefined) ||
    []

  const {
    handleApproveSong,
    handleRejectSong,
    handleChangeStatus,
    isUpdatingSongStatus,
    processingSongId,
    processingAction,
    validationErrors,
    isSendingReview,
    handleSendReview,
    editingState,
    feeValues,
    handleFeeEdit,
    handleFeeChange,
    handleFeeSave,
    handleFeeCancel,
    songsToSubmit,
  } = usePublisherApprovalLyrics({
    requestId,
    selectedRequest,
    apiUrl,
    onDrawerClose,
    onReviewSuccess,
  })

  return (
    <Box display="flex" flexDirection="column" flex={1} sx={{ bgcolor: 'background.paper' }}>
      <Box flex={1} sx={{ overflowY: 'auto', bgcolor: 'background.paper' }}>
        <Stack spacing={0.5}>
          {songs.map((song, index) => {
            const draftReviewSong = draftReviewSongs.find(
              draftSong => draftSong.songId === song.id,
            ) || {
              songId: song.id,
              isApproved: null,
            }

            return (
              <SongItemApprovalLyrics
                key={song.id}
                song={song}
                enums={enums}
                onApprove={handleApproveSong}
                onReject={handleRejectSong}
                onChangeStatus={handleChangeStatus}
                isLoading={isUpdatingSongStatus}
                initialLoading={initialLoading}
                processingSongId={processingSongId}
                processingAction={processingAction}
                draftReviewSong={draftReviewSong}
                isEditing={Boolean(editingState[String(song.id)])}
                feeValue={feeValues[String(song.id)] || ''}
                onFeeEdit={handleFeeEdit}
                onFeeChange={handleFeeChange}
                onFeeSave={handleFeeSave}
                onFeeCancel={handleFeeCancel}
                validationError={validationErrors[`song_${index}_lyrics_publisher_fee`]?.[0]}
              />
            )
          })}
        </Stack>
      </Box>
      <SongsListFooter
        onSendReview={handleSendReview}
        isSendingReview={isSendingReview}
        isLoading={isUpdatingSongStatus}
        initialLoading={initialLoading}
        isRequestSubmitted={isRequestSubmitted}
        songs={songsToSubmit}
      />
    </Box>
  )
}
